import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	checkboxInput: {
		width: '100%',
		paddingBottom: '1rem'
	},
	checkboxInputTypography: {
		fontWeight: '600',
		color: theme.palette.primary.grey,
		width: '100%',
		padding: '0',
		textAlign: 'left'
	}
}));
